import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { business } from "../config/business";
import ctaImageDefault from "./assets/fabrication-hero.jpg";

// Shared split image/panel closing CTA — reused across pages instead of each
// page hand-rolling its own centered CTA band.
const CTABand = ({
  title = "Start Your Project With Confidence",
  description = "Partner with TR Structures for industrial buildings and fabrication — where quality meets reliability.",
  image = ctaImageDefault,
  primaryText = "Send Enquiry Now",
  primaryLink = "/enquiry",
}) => {
  return (
    <section className="relative overflow-hidden">
      <div className="grid lg:grid-cols-2">
        <div className="relative min-h-[280px] lg:min-h-[380px]">
          <img
            src={image}
            alt="TR Structures project in progress"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-foreground/50" aria-hidden="true" />
        </div>
        <div className="bg-primary text-white flex items-center">
          <div className="p-10 md:p-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-5">{title}</h2>
            <p className="text-white/90 text-lg mb-8 max-w-md">{description}</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to={primaryLink}
                className="bg-white text-primary px-8 py-4 rounded-lg font-montserrat font-bold text-center hover:bg-gray-100 transition"
              >
                {primaryText}
              </Link>
              <a
                href={business.whatsapp.href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-8 py-4 rounded-lg font-montserrat font-bold hover:bg-[#20bd5a] transition"
              >
                <FaWhatsapp size={20} aria-hidden="true" /> WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABand;
